module.exports = __webpack_public_path__ + "img/With Redtea_.348bf4aa.png";